import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/new-employees.svg'


const _hoisted_1 = { class: "card border-0 rounded-3 bg-white mb-4" }
const _hoisted_2 = { class: "custom-padding-30 position-relative" }
const _hoisted_3 = { class: "chart-position top-50 translate-middle-y me-1 mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex align-items-center mb-4 pb-2\"><div class=\"flex-shrink-0\"><div class=\"text-center rounded-2 bg-primary-div-50\" style=\"width:44px;height:44px;line-height:44px;\"><img src=\"" + _imports_0 + "\" alt=\"new-employees\"></div></div><div class=\"flex-grow-1 ms-3\"><span class=\"d-block mb-1\">New Employees</span><h3 class=\"fw-semibold fs-20 mb-0\">8,24</h3></div></div><div class=\"d-flex align-items-center\"><i class=\"ri-arrow-right-up-line d-inline-block text-center rounded-1 fs-18 text-success-50\" style=\"width:26px;height:26px;line-height:26px;background-color:#d8ffc8;\"></i><p class=\"ms-2\"><span class=\"text-secondary fw-medium\">+10%</span> last year </p></div>", 2)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "radialBar",
              height: "140",
              options: _ctx.newEmployees,
              series: _ctx.employees
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}